export default "__VITE_ASSET__9065f8a8__"